import React from "react";
import { Row, Col, Form, Input, Select, DatePicker, Typography, theme } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { Utils } from "../../../Utilities/Utils";

const { Text } = Typography;

export const UserProfileFormSection: React.FC = () => {
  const { token } = theme.useToken();

  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
        <UserOutlined style={{ color: token.colorPrimary, fontSize: 14 }} />
        <Text strong style={{ fontSize: 12, color: token.colorTextHeading, textTransform: "uppercase", letterSpacing: "0.05em" }}>
          Profile Information
        </Text>
      </div>

      <Row gutter={[12, 14]}>
        <Col span={6}>
          <Form.Item label="Title" name={["name", "title"]} style={{ marginBottom: 0 }}>
            <Select
              placeholder="Title"
              options={[
                { value: "Mr", label: "Mr" },
                { value: "Mrs", label: "Mrs" },
                { value: "Miss", label: "Miss" },
                { value: "Ms", label: "Ms" },
                { value: "Dr", label: "Dr" },
                { value: "Sir", label: "Sir" },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={9}>
          <Form.Item
            label="First name"
            name={["name", "first"]}
            style={{ marginBottom: 0 }}
            rules={[
              { required: true, message: "First name is required" },
              { validator: Utils.validateWhiteSpace },
            ]}
          >
            <Input
              placeholder="First name"
              onKeyPress={(e: any) => Utils.ValidateCharOnly(e)}
              onInput={(e: any) =>
                (e.target.value = e.target.value.length > 1 ? e.target.value : e.target.value.toUpperCase())
              }
            />
          </Form.Item>
        </Col>
        <Col span={9}>
          <Form.Item
            label="Last name"
            name={["name", "last"]}
            style={{ marginBottom: 0 }}
            rules={[
              { required: true, message: "Last name is required" },
              { validator: Utils.validateWhiteSpace },
            ]}
          >
            <Input
              placeholder="Last name"
              onKeyPress={(e: any) => Utils.ValidateCharOnly(e)}
              onInput={(e: any) =>
                (e.target.value = e.target.value.length > 1 ? e.target.value : e.target.value.toUpperCase())
              }
            />
          </Form.Item>
        </Col>

        <Col span={14}>
          <Form.Item label="Email address" name="email" style={{ marginBottom: 0 }}>
            <Input
              disabled
              prefix={<LockOutlined style={{ color: token.colorTextDescription, fontSize: 12 }} />}
              style={{ background: token.colorFillAlter, cursor: "not-allowed" }}
            />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item label="Phone number" name="phoneNumber" style={{ marginBottom: 0 }}>
            <Input
              placeholder="Phone number"
              onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
              maxLength={10}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item label="Gender" name="gender" style={{ marginBottom: 0 }}>
            <Select
              placeholder="Select gender"
              options={[
                { value: 1, label: "Male" },
                { value: 2, label: "Female" },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Birth date" name="birthDate" style={{ marginBottom: 0 }}>
            <DatePicker
              style={{ width: "100%" }}
              placeholder="DD/MM/YYYY"
              format="DD/MM/YYYY"
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};
